import {mapRecordToItems} from "@/helpers/mapRecordToItems.helper";

export enum TerminationFields {
    RECURRING_ITEMS = 'recurringItems',
    TERMINATION_REASON = 'terminationReason',
    DESCRIPTION = 'description',
    DEACTIVATE_RECURRING_ITEMS_AT = 'deactivateRecurringItemsAt',
    DEACTIVATE_CUSTOMER_AT = 'deactivateCustomerAt',
    DEACTIVATE_STUDENT_AT = 'deactivateStudentAt',
    DEACTIVATE_COURSES_AT = 'terminateCoursesAt',
    DUE_DATE = 'dueDate',
    COURSE_CUSTOM_IDS = 'courseCustomIds',
    MAIL = 'mail',
    STUDENT = 'student',
    CUSTOMER = 'customer',
    INVOICE_CYCLE = 'invoiceCycle',
    TEACHERS = 'teachers',
    TERMINATION_LOG = 'terminationLog',
    CREATOR = 'creator',
    RECEIVED_AT = 'receivedAt',
    SOURCE = 'source',
    HISTORY = 'history',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}

export namespace TerminationFields {
    type Data = {
        text: string;
        readOnly?: true;
        updateOnly?: true;
    }

    export const Record: Record<TerminationFields, Data> = {
        [TerminationFields.RECURRING_ITEMS]: {
            text: 'Wiederkehrende Produkte',
        },
        [TerminationFields.TERMINATION_REASON]: {
            text: 'Kündigungsgrund',
        },
        [TerminationFields.DESCRIPTION]: {
            text: 'Beschreibung',
        },
        [TerminationFields.DEACTIVATE_RECURRING_ITEMS_AT]: {
            text: 'Abos deaktivieren am',
        },
        [TerminationFields.DEACTIVATE_CUSTOMER_AT]: {
            text: 'Kunde deaktivieren am',
        },
        [TerminationFields.DEACTIVATE_STUDENT_AT]: {
            text: 'Schüler deaktivieren am',
        },
        [TerminationFields.DEACTIVATE_COURSES_AT]: {
            text: 'Kurse beenden am',
        },
        [TerminationFields.DUE_DATE]: {
            text: 'Fällig am',
        },
        [TerminationFields.MAIL]: {
            text: 'E-Mail-Informationen',
        },
        [TerminationFields.STUDENT]: {
            text: 'Schüler',
        },
        [TerminationFields.CUSTOMER]: {
            text: 'Kunde',
        },
        [TerminationFields.INVOICE_CYCLE]: {
            text: 'Rechnungszyklus',
        },
        [TerminationFields.TEACHERS]: {
            text: 'Lehrkräfte',
        },
        [TerminationFields.TERMINATION_LOG]: {
            text: 'Protokolleintrag',
        },
        [TerminationFields.CREATOR]: {
            text: 'Erstellt von',
        },
        [TerminationFields.RECEIVED_AT]: {
            text: 'Eingang der Kündigung',
        },
        [TerminationFields.SOURCE]: {
            text: 'Erfasst aus',
            readOnly: true,
        },
        [TerminationFields.HISTORY]: {
            text: 'Verlauf',
            readOnly: true,
        },
        [TerminationFields.CREATED_AT]: {
            text: 'Erstellt am',
            readOnly: true,
        },
        [TerminationFields.UPDATED_AT]: {
            text: 'Aktualisiert am',
            readOnly: true,
        },
        [TerminationFields.COURSE_CUSTOM_IDS]: {
            text: 'Kursnummern',
            readOnly: true,
        },
    };

    export const Items = mapRecordToItems(Record);
}
